// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"79c52fa8","2995":"1320daef","6768":"1320daef","9628":"ffe73276"}[chunkId] + ".chunk.css";
};